var map = {
	"./BWFilesSection.js": 47326,
	"./ClustalAlignmentForm.js": 65953,
	"./DataFilesSection.js": 55553,
	"./DatasetRecordClasses.DatasetRecordClass.js": 58196,
	"./Sequence.js": 10353,
	"./UserDatasetBWFiles.js": 42333,
	"./UserDatasetRecordClasses.UserDatasetRecordClass.js": 25630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75788;